import type { FeedbackSurveyQuestion } from '@year13/kui/components/KUI/Unified/Completion/FeedbackSurvey/types';

import {
  normalizeFeedbackSurveyScaleQuestion,
} from '@year13/kui/components/KUI/Unified/Completion/FeedbackSurvey/types';

import type { FeedbackSurveyDefinitionFieldsFragment } from '~/graphql/generated/graphql';

import { FeedbackSurveyQuestionType } from '~/graphql/generated/graphql';

// Off the shared definition fragment, not off one of its two call sites: the page query and the
// completion payload both select it, and typing this against either would make the other's
// questions a different type at the point they are handed over.
type RawQuestions = FeedbackSurveyDefinitionFieldsFragment['questions'];

const exhaustiveQuestionType = (x: never): never => {
  throw new Error(`Unhandled FeedbackSurveyQuestionType: ${String(x)}`);
};

export const mapFeedbackSurveyQuestions = (questions: RawQuestions): FeedbackSurveyQuestion[] =>
  questions.map((q): FeedbackSurveyQuestion => {
    switch (q.type) {
      case FeedbackSurveyQuestionType.Scale:
        if ('min' in q && 'max' in q) {
          // Rebuilt field by field rather than spread, because normalising the end labels means
          // dropping them — so every field the survey renders has to be named here. Both wordings
          // travel: which of the two a question carries is the instrument's to decide, not this
          // mapper's, and dropping one blanks the heading over an answerable control.
          return normalizeFeedbackSurveyScaleQuestion({
            key: q.key,
            label: q.label,
            labelKey: q.labelKey,
            required: q.required,
            type: 'SCALE',
            min: q.min,
            max: q.max,
            minLabel: q.minLabel,
            maxLabel: q.maxLabel,
          });
        }
        return q as FeedbackSurveyQuestion;
      case FeedbackSurveyQuestionType.Dropdown:
      case FeedbackSurveyQuestionType.Likert:
      case FeedbackSurveyQuestionType.Text:
      case FeedbackSurveyQuestionType.Textarea:
      case FeedbackSurveyQuestionType.YesNo:
        return q as FeedbackSurveyQuestion;
      default:
        return exhaustiveQuestionType(q.type);
    }
  });
